export default "__VITE_ASSET__QKT6CHZ1__"